import { ArrowRightOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import { Col, Row, Space, Tag, Typography, Descriptions } from 'antd';
import { JP_DATE_FORMAT } from 'common/config/constants';
import dateUtils from 'common/helpers/date';
import { EventDetail, LayoutWidthType } from 'common/types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetEventDetailData } from 'recoil/hooks/useEventDetailData';
import { useGetLayoutWidth } from "recoil/hooks/useLayoutWidth";

const { Text, Paragraph, Link, Title } = Typography;

export interface PanelEventInfoProps {
  eventDetailData: EventDetail;
}

const BASE_SPAN = 24;
const LABEL_SPAN = 6;
const VALUE_SPAN = BASE_SPAN - LABEL_SPAN;

const PanelInfo: React.FC<PanelEventInfoProps> = ({ eventDetailData }) => {
  const { t } = useTranslation();
  const layoutWidth = useGetLayoutWidth();
  const [data, setData] = useState<EventDetail>(eventDetailData || {
    id: '',
    name: ''
  });

  useEffect(() => {
    console.log('LayoutWidth', layoutWidth);
  }, [layoutWidth])

  const isExpired = function () {
    if (eventDetailData) {
      return dateUtils.dayjs().isSameOrAfter(data.endDate, 'milliseconds');
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (eventDetailData) {
      setData(eventDetailData);
    }
  }, [eventDetailData]);

  const renderExpiredTag = (
    isExpired() ? <Tag color='#f50'>{t('RESOURCES.EVENT.LABELS.EXPIRED')}</Tag> : <></>
  );

  const renderForDesktop = (
    <>
      <Col xxl={LABEL_SPAN} xl={LABEL_SPAN} lg={24} sm={24} xs={24}>
        <Row gutter={[8, 8]} align='top'>
          <Col span={24}><Text strong>{t('RESOURCES.LABELS.NAME')}</Text></Col>
          <Col span={24}><Text strong>{t('RESOURCES.LABELS.TYPE')}</Text></Col>
          <Col span={24}><Text strong>{t('RESOURCES.LABELS.EVENT_TIME')}</Text></Col>
          <Col span={24}><Text strong>{t('RESOURCES.LABELS.RELATED_SHOP_URL')}</Text></Col>
          <Col span={24}><Text strong>{t('RESOURCES.LABELS.CONTENT')}</Text></Col>
          <Col span={24}><Text strong>{t('RESOURCES.LABELS.DESCRIPTION')}</Text></Col>
        </Row>
      </Col>
      <Col xxl={VALUE_SPAN} xl={VALUE_SPAN} lg={24} sm={24} xs={24}>
        <Row gutter={[8, 8]} align='top'>
          <Col span={24}>
            <Space>{data.name} {renderExpiredTag}</Space>
          </Col>
          <Col span={24}>
            <Space>
              {
                data.lock ? <LockOutlined /> : <UnlockOutlined />
              }
              {
                data.lock ? <Text>{t('RESOURCES.EVENT_TYPES.PRIVATE')}</Text> : <Text>{t('RESOURCES.EVENT_TYPES.PUBLIC')}</Text>
              }
            </Space>
          </Col>
          <Col span={24}>
            <Space>
              <Text>{dateUtils.formatDate(data.startDate, JP_DATE_FORMAT)}</Text>
              <Text><ArrowRightOutlined style={{ color: 'red' }} /></Text>
              <Text>{dateUtils.formatDate(data.endDate, JP_DATE_FORMAT)}</Text>
            </Space>
          </Col>
          <Col span={24}>
            {
              data.relatedShopLink ? (<Link href={data.relatedShopLink}>{data.relatedShopLink}</Link>) : '-'
            }
          </Col>
          <Col span={24}>
            <Paragraph>
              {data.content || '-'}
            </Paragraph>
          </Col>
          <Col span={24}>
            <Paragraph>
              {data.description || '-'}
            </Paragraph>
          </Col>
        </Row>
      </Col>
    </>
  );

  const renderTabletOrMobile = (
    <Col span={24}>
      <Descriptions bordered={false} colon column={1} title={<Title level={5}>{t('RESOURCES.EVENT.LABELS.TITLE')}</Title>}>
        <Descriptions.Item label={<Text strong>{t('RESOURCES.EVENT.LABELS.NAME')}</Text>}>
          <Space>{data.name} {renderExpiredTag}</Space>
        </Descriptions.Item>
        {/* <Descriptions.Item label={<Text strong>{t('RESOURCES.EVENT.LABELS.TYPE')}</Text>}>
          <Space>
            {
              data.lock ? <LockOutlined /> : <UnlockOutlined />
            }
            {
              data.lock ? <Text>{t('RESOURCES.EVENT.EVENT_TYPES.PRIVATE') + `(${t('RESOURCES.EVENT.MESSAGES.PASSCODE_HINT')})`}</Text> : <Text>{t('RESOURCES.EVENT.EVENT_TYPES.PUBLIC')}</Text>
            }
          </Space>
        </Descriptions.Item> */}
        <Descriptions.Item label={<Text strong>{t('RESOURCES.EVENT.LABELS.EVENT_TIME')}</Text>}>
          <Space>
            <Text>{dateUtils.formatDate(data.startDate, JP_DATE_FORMAT)}</Text>
            <Text><ArrowRightOutlined style={{ color: 'red' }} /></Text>
            <Text>{dateUtils.formatDate(data.endDate, JP_DATE_FORMAT)}</Text>
          </Space>
        </Descriptions.Item>
        {/* <Descriptions.Item label={<Text strong>{t('RESOURCES.EVENT.LABELS.RELATED_SHOP_URL')}</Text>}>
          {
            data.relatedShopLink ? (<Link href={data.relatedShopLink}>{data.relatedShopLink}</Link>) : '-'
          }
        </Descriptions.Item> */}
        <Descriptions.Item label={<Text strong>{t('RESOURCES.EVENT.LABELS.CONTENT')}</Text>}>
          <Paragraph>
            {data.content || '-'}
          </Paragraph>
        </Descriptions.Item>
      </Descriptions>
    </Col>
  );

  return (
    <Row gutter={[8, 8]} align='top'>
      <Col span={24}>
        
      </Col>
      {
        renderTabletOrMobile
      }
    </Row>
  );
};

export default PanelInfo;